<template>
  <DetailTemplate
    :customClass="'customer-detail detail-page'"
    v-if="getPermission('lead:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div>
          <ContactDetail
            :pageLoading="pageLoading"
            :lead="leadArr"
          ></ContactDetail>
        </div>
        <template v-if="getPermission('lead:update') && !isLeadConverted">
          <div key="0" class="">
            <template>
              <v-skeleton-loader
                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                v-if="pageLoading"
                type="button"
                height="28"
                width="200"
              >
              </v-skeleton-loader>
              <v-btn
                v-else
                class="custom-bold-button white--text"
                small
                depressed
                color="cyan"
                v-on:click.native.stop="detailDialog = true"
              >
                <v-icon left>mdi-pencil</v-icon>Update Lead Details
              </v-btn>
            </template>
          </div>
        </template>
      </v-card>
    </template>
    <template v-slot:header-title>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        width="400"
        height="28"
        type="text"
      >
      </v-skeleton-loader>
      <div class="d-flex">
        <v-tooltip
          v-if="leadArr.company_type == 'company'"
          top
          content-class="custom-top-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <h1
              v-bind="attrs"
              v-on="on"
              class="form-title custom-nowrap-ellipsis text-capitalize mr-2"
              v-if="leadArr.company_type == 'company'"
            >
              {{ leadArr.lead_name }}

              {{ getPageTitle }}
            </h1>
          </template>
          <span
            >{{ leadArr.lead_name }}

            {{ getPageTitle }}</span
          >
        </v-tooltip>
        <h1
          class="form-title custom-nowrap-ellipsis text-capitalize mr-2"
          v-else
        >
          <template
            v-if="
              leadArr &&
              leadArr.default_person &&
              leadArr.default_person.display_name
            "
            >{{ leadArr.default_person.display_name }}</template
          >
        </h1>
      </div>
    </template>
    <template v-slot:header-action>
      <v-skeleton-loader
        class="custom-skeleton d-inline-block mr-2"
        v-if="pageLoading"
        type="button"
        height="28"
      >
      </v-skeleton-loader>
      <template>
        <div class="d-flex">
          <v-menu
            v-if="getPermission('lead:update') && !isLeadConverted"
            content-class="custom-menu-list"
            bottom
            offset-y
            left
            transition="slide-y-transition"
            :close-on-click="true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="pageLoading || statusLoading"
                :loading="statusLoading"
                class="mx-1 custom-bold-button white--text"
                color="cyan"
                v-bind="attrs"
                v-on="on"
              >
                More... <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="item in leadStatusActions"
                :key="item.action"
                link
                :disabled="leadArr.status === item.action"
                v-on:click="updateLeadStatus(item.action)"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <template v-if="!isLeadConverted">
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  class="mx-1 custom-bold-button white--text"
                  color="cyan"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="createTransaction(leadArr, 'convert_to_customer')"
                >
                  <v-icon left>mdi-account-convert</v-icon> Convert to Customer
                </v-btn>
              </template>
              <span>Click here to Convert to Customer</span>
            </v-tooltip>
          </template>

          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="goBack"
            depressed
          >
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
        </div>
      </template>
    </template>

    <template v-slot:body>
      <v-container fluid class="px-0">
        <v-tabs
          v-model="customerTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent sticky-tab-0"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#lead">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/home.svg')" />
            </span>
            Overview
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#contact-person"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg
                :src="$assetURL('media/custom-svg/contact-person.svg')"
              />
            </span>
            Contact Person
          </v-tab>

          <!-- <v-tab class="font-size-16 font-weight-600 px-8" href="#amount">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/pricing.svg')" />
            </span>
            Amount
          </v-tab> -->

          <v-tab class="font-size-16 font-weight-600 px-8" href="#meeting">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/staff.svg')" />
            </span>
            Meetings
          </v-tab>

          <v-tab class="font-size-16 font-weight-600 px-8" href="#attachment">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
            </span>
            Attachments
          </v-tab>

          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
            </span>
            History
          </v-tab>

          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#opportunities"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg
                :src="$assetURL('media/custom-svg/opportunity.svg')"
              />
            </span>
            Opportunities
          </v-tab>
        </v-tabs>
        <!-- <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: 90vh; position: relative"
        > -->
        <v-tabs-items v-model="customerTab">
          <v-tab-item v-if="getPermission('lead:view')" :value="'lead'">
            <v-row justify="center">
              <v-col md="12" lg="12">
                <!-- Basic Information Card -->
                <v-card outlined elevation="0" class="mb-4">
                  <div
                    class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="blue darken-2" small class="mr-2"
                        >mdi-information-outline</v-icon
                      >
                      <h3
                        class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                      >
                        Basic Information
                      </h3>
                    </div>
                  </div>
                  <v-card-text class="pa-4 font-size-16">
                    <ContactDetailOverview
                      :pageLoading="pageLoading"
                      :lead="leadArr"
                    ></ContactDetailOverview>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="12" lg="12">
                <!-- Description Card -->
                <v-card outlined elevation="0" class="mb-4">
                  <div
                    class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="orange darken-2" small class="mr-2"
                        >mdi-text-box-outline</v-icon
                      >
                      <h3
                        class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                      >
                        Description
                      </h3>
                    </div>
                  </div>
                  <v-card-text class="pa-4 font-size-16">
                    <span>
                      <template v-if="leadArr.internal_remark">
                        {{ leadArr.internal_remark }}
                      </template>
                      <template v-else>
                        <em class="text-muted">no description</em>
                      </template>
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="12" lg="12">
                <!-- Email Reply Card -->
                <v-card outlined elevation="0" class="mb-4">
                  <div
                    class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="cyan darken-2" small class="mr-2"
                        >mdi-email-outline</v-icon
                      >
                      <h3
                        class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                      >
                        Email Reply
                      </h3>
                    </div>
                  </div>
                  <v-card-text class="pa-4 font-size-16">
                    <span>
                      <template v-if="leadArr.email_reply">
                        {{ leadArr.email_reply }}
                      </template>
                      <template v-else>
                        <em class="text-muted">no email reply</em>
                      </template>
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>

              <!--  <v-col md="12" lg="12">
                    <v-card flat class="custom-grey-border remove-border-radius mb-4 h-100">
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">
                            Extra Information</span>
                          </v-card-title>
                          <v-card-text class="p-6 font-size-16">
                            <v-skeleton-loader
                              class="custom-skeleton"
                              v-if="!leadArr"
                              type="text@5"
                            >
                             </v-skeleton-loader>

                            <table v-else class="width-100">
                              <tr>
                                  <td
                                    width="200"
                                    class="py-1 font-size-18 font-weight-500"
                                  >
                                    Public
                                  </td>
                                  <td class="font-size-18 text-lowercase">
                                      <template v-if="leadArr.is_public">
                                        <span class="text-h6 green--text">Yes</span>
                                      </template>
                                      <span v-else class="text-h6 red--text">No</span>
                                    
                                  </td>
                              </tr>

                              <tr>
                                  <td
                                    width="200"
                                    class="py-1 font-size-18 font-weight-500"
                                  >
                                    Contacted Today
                                  </td>
                                  <td class="font-size-18 text-lowercase">
                                      <template v-if="leadArr.contacted_today">
                                        <span class="text-h6 green--text">Yes</span>
                                      </template>
                                      <span v-else class="text-h6 red--text">No</span>
                                    
                                  </td>
                              </tr>
                            </table>
                           
                          </v-card-text>
                    </v-card>
                </v-col> -->

              <CustomFormDetail
                v-if="leadArr.id"
                module="customer"
                :module-id="leadArr.id"
              />
            </v-row>
          </v-tab-item>
          <v-tab-item :value="'contact-person'">
            <v-expansion-panels v-if="false" v-model="panel" inset>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <v-row no-gutters>
                      <v-col cols="6" class="margin-auto">
                        <h2
                          class="margin-auto color-custom-blue font-weight-600"
                        >
                          Contact Persons
                        </h2>
                      </v-col>
                      <v-col cols="6">
                        <span v-if="open" key="0">
                          <template
                            v-if="
                              getPermission('contact-person:create') &&
                              !isLeadConverted
                            "
                          >
                            <span class="float-right">
                              <v-skeleton-loader
                                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                v-if="pageLoading"
                                type="button"
                                height="28"
                                width="200"
                              >
                              </v-skeleton-loader>
                              <v-btn
                                depressed
                                v-else
                                class="mx-2 mr-4 custom-bold-button white--text"
                                color="cyan"
                                small
                                v-on:click.native.stop="
                                  personId = 0;
                                  personDialog = true;
                                "
                              >
                                <v-icon dark left>mdi-plus</v-icon>Create
                                Contact Person
                              </v-btn>
                            </span>
                          </template>
                          <template v-if="personSelectedRows.length > 0">
                            <!-- <template
                              v-if="getPermission('contact-person:update')"
                            >
                              <span class="float-right">
                                <v-skeleton-loader
                                  class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                  v-if="pageLoading"
                                  type="button"
                                  height="28"
                                  width="150"
                                >
                                </v-skeleton-loader>
                                <v-menu
                                  v-else
                                  :close-on-click="true"
                                  bottom
                                  content-class="custom-menu-list"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      depressed
                                      v-bind="attrs"
                                      v-on="on"
                                      class="mx-2 custom-bold-button white--text"
                                      color="cyan"
                                      small
                                    >
                                      <v-icon small dark left
                                        >mdi-chevron-down</v-icon
                                      >Bulk Action
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <template
                                      v-for="(item, index) in personBulkActions"
                                    >
                                      <template>
                                        <template
                                          v-if="
                                            (item.action == 'default' &&
                                              personSelectedRows.length == 1) ||
                                            item.action != 'default'
                                          "
                                        >
                                          <v-list-item
                                            :key="index"
                                            link
                                            v-on:click="
                                              updateCustomerPerson(item)
                                            "
                                          >
                                            <v-list-item-title
                                              class="font-weight-400 my-2 font-size-14"
                                              >{{
                                                item.title
                                              }}</v-list-item-title
                                            >
                                          </v-list-item>
                                        </template>
                                      </template>
                                    </template>
                                  </v-list>
                                </v-menu>
                              </span>
                            </template> -->
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ContactPerson
                    :pageLoading="pageLoading"
                    :lead="leadArr"
                    v-on:selectLead="showUpdateDialog"
                    v-on:selectedRows="updatePersonSelectedRows"
                  ></ContactPerson>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row no-gutters>
              <v-col cols="6" class="margin-auto">
                <h2 class="margin-auto color-custom-blue font-weight-600">
                  Contact Persons
                </h2>
              </v-col>
              <v-col cols="6">
                <span>
                  <template
                    v-if="
                      getPermission('contact-person:create') && !isLeadConverted
                    "
                  >
                    <span class="float-right">
                      <v-skeleton-loader
                        class="custom-skeleton d-inline-block custom-skeleton-full-width"
                        v-if="pageLoading"
                        type="button"
                        height="28"
                        width="200"
                      >
                      </v-skeleton-loader>
                      <v-btn
                        depressed
                        v-else
                        class="mx-2 mr-4 custom-bold-button white--text"
                        color="cyan"
                        small
                        v-on:click.native.stop="
                          personId = 0;
                          personDialog = true;
                        "
                      >
                        <v-icon dark left>mdi-plus</v-icon>Create Contact Person
                      </v-btn>
                    </span>
                  </template>
                  <template v-if="personSelectedRows.length > 0">
                    <!-- <template v-if="getPermission('contact-person:update')">
                      <span class="float-right">
                        <v-skeleton-loader
                          class="custom-skeleton d-inline-block custom-skeleton-full-width"
                          v-if="pageLoading"
                          type="button"
                          height="28"
                          width="150"
                        >
                        </v-skeleton-loader>
                        <v-menu
                          v-else
                          :close-on-click="true"
                          bottom
                          content-class="custom-menu-list"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              v-bind="attrs"
                              v-on="on"
                              class="mx-2 custom-bold-button white--text"
                              color="cyan"
                              small
                            >
                              <v-icon small dark left>mdi-chevron-down</v-icon
                              >Bulk Action
                            </v-btn>
                          </template>
                          <v-list>
                            <template
                              v-for="(item, index) in personBulkActions"
                            >
                              <template>
                                <template
                                  v-if="
                                    (item.action == 'default' &&
                                      personSelectedRows.length == 1) ||
                                    item.action != 'default'
                                  "
                                >
                                  <v-list-item
                                    :key="index"
                                    link
                                    v-on:click="updateCustomerPerson(item)"
                                  >
                                    <v-list-item-title
                                      class="font-weight-400 my-2 font-size-14"
                                      >{{ item.title }}</v-list-item-title
                                    >
                                  </v-list-item>
                                </template>
                              </template>
                            </template>
                          </v-list>
                        </v-menu>
                      </span>
                    </template> -->
                  </template>
                </span>
              </v-col>
            </v-row>
            <v-col cols="12" class="pa-0">
              <ContactPerson
                :pageLoading="pageLoading"
                :lead="leadArr"
                v-on:selectLead="showUpdateDialog"
                v-on:selectedRows="updatePersonSelectedRows"
                v-on:refress:data="getLead"
                v-on:success="getLead"
              ></ContactPerson>
            </v-col>
          </v-tab-item>

          <v-tab-item v-if="getPermission('customer:view')" :value="'amount'">
            <Amount :lead="leadArr"></Amount>
          </v-tab-item>

          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="lead"
              :type_id="leadArr.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item v-if="getPermission('customer:view')" :value="'meeting'">
            <MeetingDetails
              :type="1"
              :relatedTo="'Leads'"
              :parentId="leadArr.id"
              :assigneeList="options.userList"
            />
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('customer:view')"
            :value="'attachment'"
          >
            <div class="service-detail-height">
              <AdditionalDocuments
                :type-id="leadArr.id"
                class="mx-0 mb-3"
                type-text="Lead Attachments"
                :type="20"
                :extensive="false"
              ></AdditionalDocuments>
            </div>
          </v-tab-item>
          <v-tab-item :value="'opportunities'">
            <v-expansion-panels v-if="false" v-model="panel" inset>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <v-row no-gutters>
                      <v-col cols="6" class="margin-auto">
                        <h2
                          class="margin-auto color-custom-blue font-weight-600"
                        >
                          Contact Persons
                        </h2>
                      </v-col>
                      <v-col cols="6">
                        <span v-if="open" key="0">
                          <template
                            v-if="getPermission('opportunities:create')"
                          >
                            <span class="float-right">
                              <v-skeleton-loader
                                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                v-if="pageLoading"
                                type="button"
                                height="28"
                                width="200"
                              >
                              </v-skeleton-loader>
                              <v-btn
                                depressed
                                v-else
                                class="mx-2 mr-4 custom-bold-button white--text"
                                color="cyan"
                                small
                                v-on:click.native.stop="
                                  personId = 0;
                                  personDialog = true;
                                "
                              >
                                <v-icon dark left>mdi-plus</v-icon>Create
                                Opportunity
                              </v-btn>
                            </span>
                          </template>
                          <template v-if="personSelectedRows.length > 0">
                            <template
                              v-if="getPermission('opportunities:update')"
                            >
                              <span class="float-right">
                                <v-skeleton-loader
                                  class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                  v-if="pageLoading"
                                  type="button"
                                  height="28"
                                  width="150"
                                >
                                </v-skeleton-loader>
                                <v-menu
                                  v-else
                                  :close-on-click="true"
                                  bottom
                                  content-class="custom-menu-list"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      depressed
                                      v-bind="attrs"
                                      v-on="on"
                                      class="mx-2 custom-bold-button white--text"
                                      color="cyan"
                                      small
                                    >
                                      <v-icon small dark left
                                        >mdi-chevron-down</v-icon
                                      >Bulk Action
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <template
                                      v-for="(
                                        item, index
                                      ) in propertyBulkActions"
                                    >
                                      <template>
                                        <template
                                          v-if="
                                            (item.action == 'default' &&
                                              personSelectedRows.length == 1) ||
                                            item.action != 'default'
                                          "
                                        >
                                          <v-list-item
                                            :key="index"
                                            link
                                            v-on:click="
                                              updateCustomerPerson(item)
                                            "
                                          >
                                            <v-list-item-title
                                              class="font-weight-400 my-2 font-size-14"
                                              >{{
                                                item.title
                                              }}</v-list-item-title
                                            >
                                          </v-list-item>
                                        </template>
                                      </template>
                                    </template>
                                  </v-list>
                                </v-menu>
                              </span>
                            </template>
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <Opportunity
                    :pageLoading="pageLoading"
                    :lead="leadArr"
                    v-on:selectLead="showUpdateDialog"
                    v-on:selectedRows="updatePersonSelectedRows"
                  ></Opportunity>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row no-gutters>
              <v-col cols="6" class="margin-auto">
                <h2 class="margin-auto color-custom-blue font-weight-600">
                  Opportunities
                </h2>
              </v-col>
              <v-col cols="6">
                <span>
                  <template>
                    <span class="float-right">
                      <v-skeleton-loader
                        class="custom-skeleton d-inline-block custom-skeleton-full-width"
                        v-if="pageLoading"
                        type="button"
                        height="28"
                        width="200"
                      >
                      </v-skeleton-loader>
                      <v-btn
                        depressed
                        v-else
                        class="mx-2 mr-4 custom-bold-button white--text"
                        color="cyan"
                        small
                        v-on:click.native.stop="createOpportunity"
                      >
                        <v-icon dark left>mdi-plus</v-icon>Create Opportunity
                      </v-btn>
                    </span>
                  </template>
                  <template v-if="personSelectedRows.length > 0">
                    <template v-if="getPermission('opportunities:update')">
                      <span class="float-right">
                        <v-skeleton-loader
                          class="custom-skeleton d-inline-block custom-skeleton-full-width"
                          v-if="pageLoading"
                          type="button"
                          height="28"
                          width="150"
                        >
                        </v-skeleton-loader>
                        <v-menu
                          v-else
                          :close-on-click="true"
                          bottom
                          content-class="custom-menu-list"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              v-bind="attrs"
                              v-on="on"
                              class="mx-2 custom-bold-button white--text"
                              color="cyan"
                              small
                            >
                              <v-icon small dark left>mdi-chevron-down</v-icon
                              >Bulk Action
                            </v-btn>
                          </template>
                          <v-list>
                            <template
                              v-for="(item, index) in propertyBulkActions"
                            >
                              <template>
                                <template
                                  v-if="
                                    (item.action == 'default' &&
                                      personSelectedRows.length == 1) ||
                                    item.action != 'default'
                                  "
                                >
                                  <v-list-item
                                    :key="index"
                                    link
                                    v-on:click="updateCustomerOpportunity(item)"
                                  >
                                    <v-list-item-title
                                      class="font-weight-400 my-2 font-size-14"
                                      >{{ item.title }}</v-list-item-title
                                    >
                                  </v-list-item>
                                </template>
                              </template>
                            </template>
                          </v-list>
                        </v-menu>
                      </span>
                    </template>
                  </template>
                </span>
              </v-col>
              <v-col cols="12" class="pa-0">
                <Opportunity
                  :pageLoading="pageLoading"
                  :lead="leadArr"
                  v-on:selectOpportunity="goToOpportunity"
                  v-on:selectedRows="updatePersonSelectedRows"
                  v-on:refress:data="getLead"
                  v-on:success="getLead"
                ></Opportunity>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <!-- </perfect-scrollbar> -->

        <FullDialog
          v-if="notesDialog"
          :dialog="notesDialog"
          content-class="testdata"
        >
          <template v-slot:title
            >{{ leadArr.display_name }}(
            {{ leadArr.barcode }}
            ) Notes
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red darken-4"
              depressed
              tile
              v-on:click="notesDialog = false"
            >
              Close
            </v-btn>
          </template>
          <template v-slot:body>
            <ChatNote
              v-if="notesDialog"
              :relatedId="Number(customer)"
              :relatedType="'customer'"
              :documentTypes="33"
              create-url="customer-notes"
              get-url="customer-notes"
            ></ChatNote>
          </template>
          <!-- <template v-slot:action>
				<v-btn class="text-white" color="red darken-4" depressed tile v-on:click="closeDialog">
					Close
				</v-btn>
			</template> -->
        </FullDialog>
      </v-container>
    </template>
    <template v-slot:footer>
      <Dialog
        v-if="detailDialog"
        :commonDialog="detailDialog"
        :dialogWidth="getContactDialogWith"
      >
        <template v-slot:title>Update lead Details </template>
        <template v-slot:body>
          <v-form
            :class="{
              'pointer-events-none': !getPermission('lead:update'),
            }"
            ref="leadDetailForm"
            v-model.trim="detailForm"
            lazy-validation
            v-on:submit.stop.prevent="onDetailSubmit('leadDetailForm')"
          >
            <DialogBasicDetails
              :detail="leadArr"
              :isDialog="true"
              @update:detail="handleBasicDetailUpdate"
              :options="options"
            >
            </DialogBasicDetails>
          </v-form>
        </template>
        <template v-slot:action>
          <template v-if="getPermission('lead:update')">
            <v-btn
              depressed
              :disabled="!detailForm || formLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="onDetailSubmit('leadDetailForm')"
              >Update
            </v-btn>
          </template>
          <v-btn
            depressed
            :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="masterDialogClose"
            >Close
          </v-btn>
        </template>
      </Dialog>
      <template v-if="personDialog">
        <DialogContactPersons
          disable-one
          v-model="leadArr.persons"
          :person-dialog="personDialog"
          :do-update="!!+personId"
          :do-save="!!!+personId"
          :person-id="personId"
          :lead-id="leadArr.id"
          v-on:close="personDialog = false"
          v-on:update:person="getLead"
        ></DialogContactPersons>
      </template>

      <template v-if="personSingleDialog">
        <DialogIndividualContactPersons
          disable-one
          v-model="leadArr.persons"
          :person-dialog="personSingleDialog"
          :do-update="!!+personId"
          :do-save="!!!+personId"
          :person-id="personId"
          :customerId="leadArr.id"
          :customer="leadArr"
          type="lead"
          v-on:close="personSingleDialog = false"
          v-on:update:person="getLead"
          :options="vOptions"
        ></DialogIndividualContactPersons>
      </template>

      <template v-if="opportunityDialog">
        <DialogCreateOpportunity
          v-model="leadArr.opportunities"
          :opportunity-dialog="opportunityDialog"
          :do-update="!!+opportunityId"
          :do-save="!!!+opportunityId"
          :opportunity-id="opportunityId"
          :leadId="leadArr.id"
          :lead="leadArr"
          v-on:close="opportunityDialog = false"
          v-on:update:opportunity="getLead"
        ></DialogCreateOpportunity>
      </template>

      <template>
        <template v-if="transaction_contact_person_dialog">
          <CustomerPersonDialog
            :customerPersonDialog="transaction_contact_person_dialog"
            :customer="transaction_customer"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectCustomerPerson="selectCustomerPerson"
          >
          </CustomerPersonDialog>
        </template>
      </template>

      <PersonSelectOpportunity
        v-if="leadArr && leadArr.id"
        :dialog="contactDialog"
        v-on:close="contactDialog = false"
        :parentId="leadArr.id"
        :type="`lead`"
        @select="selectContactPerson"
      />
    </template>
  </DetailTemplate>
</template>

<script>
import FullDialog from "@/view/components/FullDialog";

import ChatNote from "@/view/pages/partials/ChatNote";
import PersonSelectOpportunity from "@/view/components/PersonSelectOpportunity.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CLEAR_ERROR,
  GET,
  POST,
  PATCH,
  QUERY,
} from "@/core/services/store/request.module";

import ContactDetail from "@/view/pages/lead-new/detail/overview/Contact-Detail.vue";
import MeetingDetails from "@/view/components/MeetingDetails.vue";
import ContactDetailOverview from "@/view/pages/lead-new/detail/overview/Contact-Detail-Overview.vue";
import Amount from "@/view/pages/lead-new/detail/overview/Amount.vue";
import ContactPerson from "@/view/pages/lead-new/detail/overview/Contact-Person.vue";
import Opportunity from "@/view/pages/lead-new/detail/overview/Opportunity.vue";
import DialogIndividualContactPersons from "@/view/pages/customer/create-or-update/Update-Single-Person-Individual-Customer";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import DialogBasicDetails from "@/view/pages/lead-new/create-or-update/Basic-Details.vue";
import CustomerMixin from "@/core/plugins/customer-mixin";
import PatchCustomerMixin from "@/core/lib/customer/patch.customer.mixin";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";

import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import DialogContactPersons from "@/view/pages/lead-new/create-or-update/Create-Contact-Person";
import DialogCreateOpportunity from "@/view/pages/lead-new/create-or-update/Create-Opportunity";

import CustomFormDetail from "@/view/pages/custom-field-v2/CustomFormDetail.vue";
import { mapGetters } from "vuex";

import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";

export default {
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, PatchCustomerMixin],
  name: "customer-detail",
  title: "Customer",
  data() {
    return {
      notesDialog: false,
      customerTab: "lead",
      basicDetails: {},
      persons: [],
      lead: 0,
      invoiceId: 0,
      serviceFormDialog: false,
      pageLoading: true,
      resetPasswordDialog: false,
      resetPasswordLoading: false,
      deleteDialog: false,
      leadArr: {},
      options: {},
      createTransactions: [],
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "lead",
          disabled: false,
        },
        {
          title: "Contact Person",
          icon: "mdi-phone",
          key: "contact-person",
          disabled: false,
        },

        {
          title: "History",
          icon: "mdi-credit-card",
          key: "history",
          disabled: false,
        },
      ],
      leadOptions: [
        {
          title: "Convert to Customer",
          action: "convert_to_customer",
        },
      ],
      customerMoreAction: [
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          action: "inactive",
        },
      ],
      panel: 0,
      personSelectedRows: [],
      propertySelectedRows: [],
      contactDetail: {},
      contactPerson: [],
      detailForm: true,
      detailDialog: false,
      formLoading: false,
      statusLoading: false,
      personId: 0,
      personForm: true,
      personDialog: false,
      personSingleDialog: false,
      opportunityId: 0,
      opportunityForm: true,
      opportunityDialog: false,
      propertyId: 0,
      propertyForm: true,
      propertyDialog: false,
      billingForm: true,
      billingDialog: false,
      contactDialog: false,
      leadStatusActions: [
        {
          title: "Mark as Not Contacted",
          action: "Not Contacted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Follow Up",
          action: "Follow Up",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Meeting",
          action: "Meeting",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Converted to Customer",
          action: "Converted to Customer",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "Rejected",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Accepted",
          action: "Accepted",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  components: {
    ContactDetail,
    MeetingDetails,
    ContactDetailOverview,
    ContactPerson,
    Opportunity,
    Dialog,
    DialogBasicDetails,
    DialogContactPersons,
    DialogCreateOpportunity,
    DialogIndividualContactPersons,
    DetailTemplate,
    CustomerPersonDialog,
    InternalHistoryDetail,
    CustomFormDetail,
    AdditionalDocuments,
    ChatNote,
    FullDialog,
    Amount,
    PersonSelectOpportunity,
  },
  watch: {
    panel() {
      this.masterDialogClose();
    },
  },
  methods: {
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer/options" })
        .then(({ data }) => {
          _this.options = data.options;
          _this.barcode = data.barcode;
          _this.options.allow_zones = data.allow_zones;
          _this.options.active_zones = data.active_zones;
          _this.options.userList = data.userList;
          _this.options.all_tags = data.all_tags;
          _this.options.all_cms_categories = data.all_cms_categories;
        })
        .catch((error) => {
          _this.logError(error);
        });

      // Fetch companies for dropdown
      _this.$store
        .dispatch(QUERY, {
          url: "customer",
          data: { entity: 1, status: "all", all: true, filter_type: "company" },
        })
        .then(({ data }) => {
          _this.$set(_this.options, "companies", data.rows || data || []);
          console.log("Companies fetched:", _this.options.companies);
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    handleBasicDetailUpdate(val) {
      const { persons, ...rest } = val;
      this.basicDetails = { ...rest };
      this.persons = [...persons];
    },

    createTransaction(lead, param) {
      const _this = this;
      const transaction_type = _this.lodash.toString(param);

      if (transaction_type === "convert_to_customer") {
        _this.$router.push(
          _this.getDefaultRoute("customer.create", {
            query: {
              lead: lead.id,
            },
          })
        );
      }
    },

    async onDetailSubmit(formRef) {
      const _this = this;

      try {
        if (!_this.$refs[formRef].validate()) {
          return false;
        }

        _this.pageLoading = true;
        _this.formLoading = true;
        _this.$store.dispatch(CLEAR_ERROR, {});

        let formData = new Object();

        if (_this.lodash.isEmpty(_this.basicDetails) === false) {
          for (let key in _this.basicDetails) {
            formData[key] = _this.basicDetails[key];
          }
        }

        if (_this.lodash.isEmpty(formData) === false) {
          await _this.$store.dispatch(POST, {
            url: "leads/" + _this.lead,
            data: formData,
          });
        }
        _this.getLead();
      } catch (error) {
        _this.formLoading = false;
        _this.pageLoading = false;
        //ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },

    pushToVisit() {
      const _this = this;
      _this.$router.push(
        _this.getDefaultRoute("job.create", {
          query: {
            customer: _this.transaction_customer,
            type: this.jobType,
          },
        })
      );
    },

    getLead() {
      this.pageLoading = true;
      return this.$store
        .dispatch(GET, {
          url: `leads/${this.lead}`,
        })
        .then((response) => {
          this.leadArr = response.data;
          const { persons, ...rest } = this.leadArr;
          this.basicDetails = { ...rest };
          this.persons = [...persons];

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Lead", route: "lead" },
            { title: "Detail" },
            { title: this.leadArr.barcode },
          ]);
          this.masterDialogClose();
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
          this.formLoading = false;
        });
    },

    updateLeadStatus(status) {
      const _this = this;
      _this.statusLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "leads/status",
          data: { lead: [Number(_this.lead)], status },
        })
        .then(() => _this.getLead())
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.statusLoading = false;
        });
    },

    resetPassword() {
      this.$refs.passwordUpdateRef.onSubmit();
    },
    resetPasswordSuccess() {
      this.resetPasswordDialog = false;
    },
    rereshDetails() {
      let _this = this;
      _this
        .getCustomer()
        .then((response) => {
          _this.leadArr = response;
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Customer", route: "customer" },
            { title: "Detail" },
            { title: response.barcode },
          ]);
        })
        .catch((error) => {
          _this.logError(error);
          _this.$router.go(-1);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateMoreAction(action) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchCustomer(_this.customer, formData)
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    activeInactive(data) {
      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-customer/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getCustomer();
        });
    },
    updatePropertyAddress(param) {
      this.propertyAddress = param;
    },
    updateBillingAddress(param) {
      this.billingAddress = param;
    },
    updateContactDetail(param) {
      this.contactDetail = param;
    },
    updateContactPerson(param) {
      this.contactPerson = param;
    },
    updateNotification(param) {
      this.notification = param;
    },
    updatePersonSelectedRows(param) {
      this.bulkRows = { persons: param };
      this.personSelectedRows = param;
    },
    updatePropertySelectedRows(param) {
      this.bulkRows = { property: param };
      this.propertySelectedRows = param;
    },
    updateCustomerPerson({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
        case "default":
          formData.default = 1;
          break;
      }
      _this
        .patchCustomerContactPerson(
          _this.customer,
          _this.personSelectedRows,
          formData
        )
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateCustomerOpportunity({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchCustomerOpportunity(
          _this.lead,
          _this.personSelectedRows,
          formData
        )
        .then(() => {
          _this.getLead();
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateCustomerProperty({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchCustomerProperty(
          _this.customer,
          _this.propertySelectedRows,
          formData
        )
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    showUpdateDialog(param) {
      this.personId = param;
      this.$nextTick(() => {
        this.personDialog = true;
      });
    },

    goToOpportunity(opportunityId) {
      this.$router.push(
        this.getDefaultRoute("opportunity.detail", {
          params: { id: opportunityId },
        })
      );
    },

    createOpportunity() {
      this.contactDialog = true;
    },

    selectContactPerson(person) {
      this.contactDialog = false;
      this.$router.push(
        this.getDefaultRoute("opportunity.create", {
          query: {
            type: "lead",
            lead: this.lead,
            person: person.id,
          },
        })
      );
    },

    masterDialogClose() {
      this.$root.$emit("clearSelection", true);
      this.personSelectedRows = [];
      this.propertySelectedRows = [];
      this.basicDetail = {};
      this.contactPerson = [];
      this.detailForm = true;
      this.detailDialog = false;
      this.formLoading = false;
      this.personId = 0;
      this.personForm = true;
      this.personDialog = false;
      this.personSingleDialog = false;
      this.opportunityId = 0;
      this.opportunityForm = true;
      this.opportunityDialog = false;
      this.contactDialog = false;
      this.deleteDialog = false;
    },
  },

  mounted() {
    const _this = this;

    _this.checkTransactionPermission();
    _this.checkTabPermission();
    _this.getLead();
    _this.getOptions();
  },

  created() {
    const _this = this;
    _this.lead = _this.$route.params.id;

    if (!_this.lead || _this.lead <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.customerTab = _this.$route.query.tab;
    }
  },
  computed: {
    ...mapGetters(["gActiveFormFields", "vOptions"]),
    isLeadConverted() {
      const convertedStatus = "converted to customer";
      const leadStatus = String(this.leadArr.status || "").toLowerCase();

      return (
        Number(this.leadArr.converted_to_customer) === 1 ||
        leadStatus === convertedStatus
      );
    },
    getContactDialogWith() {
      if (window.innerWidth > 1240) {
        return 1320;
      }
      return window.innerWidth - 300;
    },

    getPageTitle() {
      let result = [];
      if (this.lodash.isEmpty(this.leadArr) === false) {
        if (this.leadArr.display_name) {
          result.push(this.leadArr.display_name);
        }

        /*
        if (this.leadArr.barcode) {
          result.push(this.leadArr.barcode);
        }
        */
      }
      return result.join(" • ");
    },
  },
};
</script>
